import { ClipboardList, Sprout } from 'lucide-react';
import { cn } from '@/lib/utils';
import { configTip, type TipColab } from '../utils/tipuri-colab';

export const ICONITA_TIP = { PRACTICAL_ACTIVITY: Sprout, CLASS_EXERCISE: ClipboardList } as const;

/** Culoarea e doar intarire: tipul se citeste din text si din iconita, nu din nuanta. */
export const NUANTA_TIP: Record<TipColab, { chip: string; accent: string; iconita: string }> = {
    PRACTICAL_ACTIVITY: { chip: 'bg-success/10 text-dark', accent: 'border-l-success', iconita: 'bg-success/10 text-success' },
    // `info` (albastru), nu `primary`/`magenta`: in tema asta amandoua sunt verdele de brand, deci
    // pe ecran cele doua sectiuni ieseau de aceeasi culoare (masurat pe capturi, 2026-10-05).
    CLASS_EXERCISE: { chip: 'bg-info/10 text-dark', accent: 'border-l-info', iconita: 'bg-info/10 text-info' },
};

/** Eticheta de tip de pe card si de pe ecranul de detalii: iconita + text, pe un singur rand. */
export function EtichetaTip({ tip, className }: { tip: TipColab; className?: string }) {
    const Iconita = ICONITA_TIP[tip];
    return (
        <span
            data-colab-tip={tip}
            className={cn('inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-semibold', NUANTA_TIP[tip].chip, className)}
        >
            <Iconita className="size-3.5 shrink-0" aria-hidden />
            {configTip(tip).eticheta}
        </span>
    );
}
